// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BBJp","right":"styles_right__wSdos"};